export default __webpack_public_path__ + "static/107-min-min-7e62f6884f6e9dbad4536227217b709c.jpg";